import React, { useState } from "react";
import MediaQuery from "react-responsive";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import tp1 from "../NilaiOptimum/Tp1.png";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import Iframe from "react-iframe";
const Ctp = ({ukuranH,ukuranP}) => {
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);
	const [show11, setShow11] = useState(false);
	const [show12, setShow12] = useState(false);
	const [show13, setShow13] = useState(false);
	const [show14, setShow14] = useState(false);
	const [show15, setShow15] = useState(false);

	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
			className="container mt-2 mb-3"
		>
			<div
				style={{
					width: "80%",
					margin: "auto",
					fontSize:`${ukuranP}px`
				}}
			>
				Dika ingin memakan makanan yang bervitamin, dan dokter menganjurkan
				untuk memakan dua jenis tablet vitamin setiap hari. Tablet pertama
				mengandung 5 butir vitamin A dan 3 butir vitamin B, sedangkan tablet
				kedua mengandung 10 butir vitamin A dan 1 butir vitamin B, dokter
				menyarankan Dika untuk meminumnya tidak boleh lebih dari 20 butir
				vitamin A dan 6 butir vitamin B. Jika harga tablet pertama
				Rp400,00/butir sedangkan tablet kedua Rp600,00/butir, maka tentukan
				pengeluaran maksimum Dika untuk pembelian tablet perharinya!
				<div
					style={{
						color: "green",
						display: "flex",
						justifyContent: "space-between",
						width: "10%",
					}}
				>
					<div
						style={{
							width: "5px",
							height: "5px",
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						<SkipNextIcon />
					</div>
					<p style={{ marginLeft: "22px" }}>
						<strong>
							<u>Jawaban</u>
						</strong>
					</p>
					<div
						style={{
							width: "5px",
							height: "5px",
							animation: "scrollTop 0.2s alternate ease infinite",
						}}
					>
						<SkipPreviousIcon />
					</div>
				</div>
				<ol style={{fontSize:`${ukuranP}px`}}>
					<li>
						Pertama kita buat tabel terlebih dahulu untuk memudahkan kita dalam
						mengerjakan.
					</li>
					<div className="d-flex justify-content-center">
						<MediaQuery minWidth={476} maxWidth={1824}>
							<div style={{ width: "90%" }}>
								<table
									className="table"
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "100%",
										textAlign: "center",
									}}
								>
									<tr>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Pembatas
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Tablet 1
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Tablet 2
										</th>

										<th
											style={{
												border: "2px solid green",
											}}
										>
											Kebutuhan
										</th>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Vitamin A
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											5
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											10
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											20
										</td>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Vitamin B
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											3
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											1
										</td>

										<td
											style={{
												border: "2px solid green",
											}}
										>
											6
										</td>
									</tr>
								</table>
							</div>
						</MediaQuery>
					</div>
					<div className="d-flex justify-content-center">
						<MediaQuery maxWidth={475}>
							<div style={{ width: "90%" }}>
								<table
									className="table"
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "100%",
										textAlign: "center",
									}}
								>
									<tr>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Pembatas
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Tablet 1
										</th>
										<th
											scope="col"
											style={{
												border: "2px solid green",
											}}
										>
											Tablet 2
										</th>

										<th
											style={{
												border: "2px solid green",
											}}
										>
											Kebutuhan
										</th>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Vitamin A
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											5
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											10
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											20
										</td>
									</tr>

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Vitamin B
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											3
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											1
										</td>

										<td
											style={{
												border: "2px solid green",
											}}
										>
											6
										</td>
									</tr>
								</table>
							</div>
						</MediaQuery>
					</div>
					<div className="d-flex justify-content-center">
						<button
							className="btn btn-success btn-sm mb-2 mt-2"
							onClick={() => setShow1(true)}
						>
							Lanjut
						</button>
					</div>
					{show1 ? (
						<>
							<li>
								Selanjutnya kita memisalkan x banyaknya tablet 1 dan y banyaknya
								tablet 2
							</li>

							<div className="d-flex justify-content-center">
								<button
									className="btn btn-success btn-sm mb-2 mt-2"
									onClick={() => setShow2(true)}
								>
									Lanjut
								</button>
							</div>
							{show2 ? (
								<>
									<li>
										Karena Dika tidak boleh minum vitamin lebih dari yang
										ditentukan dokter, maka tandak ketaksamaan yang digunakan
										adalah <b>"≤"</b>
									</li>
									<div className="d-flex justify-content-center">
										<button
											className="btn btn-success btn-sm mb-2 mt-2"
											onClick={() => setShow3(true)}
										>
											Lanjut
										</button>
									</div>
									{show3 ? (
										<>
											<li>
												<p>Maka,</p>
												<p>Penggunaan Vitamin A : </p>
												<p>
													<InlineMath math="\iff" />
													<b>5x + 10y ≤ 20</b>{" "}
												</p>
												<p className="alert alert-warning fst-italic">
													Dan didapatkan satu pertidaksamaan
												</p>
												<p>Penggunaan Vitamin B :</p>
												<p>
													<i>
														<InlineMath math="\iff" /> <b>3x + y ≤ 6 </b>{" "}
													</i>{" "}
												</p>

												<p className="alert alert-warning fst-italic">
													Dan kalian sudah mendapatkan dua pertidaksamaan
												</p>
											</li>
											<li>
												Karena tidak mungkin banyaknya Tablet 1 dan Tablet 2 itu
												negatif, sehingga dapat dituliskan &nbsp;&nbsp;
												<b>
													<i>x ≥ 0</i>
												</b>
												&nbsp;&nbsp; dan&nbsp;&nbsp;
												<b>
													<i>y ≥ 0</i>
												</b>
											</li>
											<div className="d-flex justify-content-center">
												<button
													className="btn btn-success btn-sm mb-2 mt-2"
													onClick={() => setShow4(true)}
												>
													Lanjut
												</button>
											</div>
											{show4 ? (
												<>
													<li>
														Maka kita langsung bisa mendapatkan model
														matematikanya sebagai berikut
													</li>
													<p className="text-center">
														<InlineMath math="5x + 10y ≤ 20; " />
														&nbsp;&nbsp;
														<InlineMath math="3x + y ≤ 6; " />
														&nbsp;&nbsp;
														<InlineMath math="x ≥ 0; " />
														&nbsp;&nbsp;
														<InlineMath math="y ≥ 0; " />
														&nbsp;
													</p>
													<div className="d-flex justify-content-center">
														<button
															className="btn btn-success btn-sm mb-2 mt-2"
															onClick={() => setShow5(true)}
														>
															Lanjut
														</button>
													</div>
													{show5 ? (
														<>
															<li>
																Karena kita sudah mengetahui harga tablet 1 dan
																tablet 2 perbutir nya, maka kita dapatkan fungsi
																objektifnya yaitu :
															</li>
															<p className="text-center">
																<InlineMath math="f(x,y) = 400x + 600y " />
															</p>
															<div className="d-flex justify-content-center">
																<button
																	className="btn btn-success btn-sm mb-2 mt-2"
																	onClick={() => setShow6(true)}
																>
																	Lanjut
																</button>
															</div>
															{show6 ? (
																<>
																	<li>
																		Selanjutnya kita mencari titik potong
																		pada sumbu <InlineMath math="\space x \space" /> dan pada sumbu <InlineMath math="\space y \space" /> &nbsp;
																		pada <InlineMath math=" 5x + 10y = 20 " />
																		&nbsp; dan tabelnya di bawah ini
																	</li>
																	<p>
																		<MediaQuery minWidth={476} maxWidth={1824}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>

																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						4
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(4, 0)
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						2
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(0, 2)
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
																	<p>
																		<MediaQuery maxWidth={475}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						4
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						4,0
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						2
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						0,2
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
																	<p className="text-center">Maka kita dapatkan :</p>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat A = (4, 0) 
																	</div>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat B = (0, 2) 
																	</div>
																	<div className="d-flex justify-content-center">
																		<button
																			className="btn btn-success btn-sm mb-2 mt-2"
																			onClick={() => setShow7(true)}
																		>
																			Lanjut
																		</button>
																	</div>
																	{show7 ? (
																		<>
																			<li>
																				Selanjutnya kita mencari titik potong
																				pada sumbu <InlineMath math="\space x \space" /> dan pada sumbu <InlineMath math="\space y \space" /> &nbsp;
																		pada <InlineMath math=" 3x + y = 6 " />{" "}
																				dan tabelnya di bawah ini
																			</li>
																			<p>
																				<MediaQuery
																					minWidth={476}
																					maxWidth={1824}
																				>
																					<table
																						style={{
																							width: "100%",
																							textAlign: "center",
																						}}
																						className="table"
																					>
																						<tr>
																							<th
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								x
																							</th>
																							<th
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								y
																							</th>
																							<th
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								(x,y)
																							</th>
																						</tr>

																						<tr>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								2
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								0
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								(2, 0)
																							</td>
																						</tr>
																						<tr>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								0
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								6
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								(0, 6)
																							</td>
																						</tr>
																					</table>
																				</MediaQuery>
																			</p>
																			<p>
																				<MediaQuery maxWidth={475}>
																					<table
																						style={{
																							width: "100%",
																							textAlign: "center",
																						}}
																						className="table"
																					>
																						<tr>
																							<th
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								x
																							</th>
																							<th
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								y
																							</th>
																							<th
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								(x,y)
																							</th>
																						</tr>

																						<tr>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								2
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								0
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								2 &nbsp;&nbsp;,0
																							</td>
																						</tr>
																						<tr>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								0
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								6
																							</td>
																							<td
																								style={{
																									border: "2px solid green",
																								}}
																							>
																								0,6
																							</td>
																						</tr>
																					</table>
																				</MediaQuery>
																			</p>
																			<p className="text-center">Maka kita dapatkan :</p>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat C = (2, 0) 
																	</div>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat D = (0, 6) 
																	</div>
																			<div className="d-flex justify-content-center">
																				<button
																					className="btn btn-success btn-sm mb-2 mt-2"
																					onClick={() => setShow8(true)}
																				>
																					Lanjut
																				</button>
																			</div>
																			{show8 ? (
																				<>
																					<li>
																						Sehingga pada{" "}
																						<InlineMath math=" 5x + 10y ≤ 20 " />
																						, Ambil titik P(0,0), sehingga :{" "}
																					</li>
																					<p>
																						<ul>
																							<li>
																								<InlineMath math=" 5(0) + 10(0) ≤ 20 " />{" "}
																							</li>
																							<li>
																								<InlineMath math=" 0 ≤ 20 " />
																							</li>
																							<li>
																								Pertidaksamaan bernilai{" "}
																								<b>Benar</b>
																							</li>
																						</ul>
																					</p>
																					<div className="d-flex justify-content-center">
																						<button
																							className="btn btn-success btn-sm mb-2 mt-2"
																							onClick={() => setShow9(true)}
																						>
																							Lanjut
																						</button>
																					</div>
																					{show9 ? (
																						<>
																							<li>
																								Sehingga pada{" "}
																								<InlineMath math=" 3x + y ≤ 6 " />
																								, Ambil titik P(0,0), sehingga :{" "}
																							</li>
																							<p>
																								<ul>
																									<li>
																										<InlineMath math=" 3(0) + (0) ≤ 6" />{" "}
																									</li>
																									<li>
																										<InlineMath math=" 0 ≤ 6 " />
																									</li>
																									<li>
																										Pertidaksamaan bernilai{" "}
																										<b>Benar</b>
																									</li>
																								</ul>
																							</p>
																							<div className="d-flex justify-content-center">
																								<button
																									className="btn btn-success btn-sm mb-2 mt-2"
																									onClick={() =>
																										setShow10(true)
																									}
																								>
																									Lanjut
																								</button>
																							</div>
																							{show10 ? (
																								<>
																									<li>
																										Coba kamu kerjakan perintah
																										pada grafik di bawah ini,
																										agar kamu dapat melihat
																										daerah penyelesaian.
																									</li>
																									<div className="text-center alert alert-warning"><b>Petunjuk :</b> Kalian dapat melakukan zoom pada grafik seperti biasa</div>
																									<div
																										style={{
																											display: "flex",
																											justifyContent: "center",
																										}}
																									>
																										<MediaQuery
																											minWidth={476}
																											maxWidth={1824}
																										>
																											<Iframe
 scrolling="no" title="Latihan1akhirCTPoptimum" src="https://www.geogebra.org/material/iframe/id/vpynpk6w/width/810/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="810px" height="717px" allowFullScreen />
																										</MediaQuery>
																									</div>
																									<MediaQuery maxWidth={475}>
																										<Iframe
																											 scrolling="no" title="Latihan1akhirCTPoptimum" src="https://www.geogebra.org/material/iframe/id/vpynpk6w/width/810/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="200px" 
																											style={{
																												height: "200px",
																											}}
																											allowFullScreen />
																									</MediaQuery>
																									<div className="d-flex justify-content-center">
																										<button
																											className="btn btn-success btn-sm mb-2"
																											onClick={() =>
																												setShow11(true)
																											}
																										>
																											Lanjut
																										</button>
																									</div>
																									{show11 ? (
																										<>
																											<li>Maka kalian mendapatkan titik koordinat E. Titik koordinat E ini didapatkan dari perpotongan dua pertidaksamaan yaitu <InlineMath math="\space 5x + 10y ≤ 20 \space" /> dengan <InlineMath math="\space 3x + y ≤ 6 \space" /></li>
																											<li>
																												Untuk mencari titik koordinat <b>E</b> maka gunakan metode eliminasi
																												atau subsitusi agar mendapatkan nilainya.
																												
																											</li>
																											<div className="d-flex justify-content-center">
																												<button
																													className="btn btn-success btn-sm mb-2 mt-2"
																													onClick={() =>
																														setShow12(true)
																													}
																												>
																													Lanjut
																												</button>
																											</div>
																											{show12 ? (
																												<>
																													<p>
																														<ul>
																															<li>
																																Pertama kita
																																mencari nilai
																																&nbsp;&nbsp;
																																<InlineMath math="x" />{" "}
																																dengan metode
																																eliminasi.
																															</li>
																															<div className="d-flex justify-content-center">
																																<MediaQuery
																																	minWidth={476}
																																	maxWidth={
																																		1824
																																	}
																																>
																																	<TransformWrapper
																																		defaultScale={
																																			1
																																		}
																																	>
																																		<TransformComponent>
																																			<img
																																				src={
																																					tp1
																																				}
																																				alt="tp1"
																																			/>
																																		</TransformComponent>
																																	</TransformWrapper>
																																</MediaQuery>
																															</div>
																															<MediaQuery
																																maxWidth={475}
																															>
																																<TransformWrapper
																																	defaultScale={
																																		1
																																	}
																																>
																																	<TransformComponent>
																																		<img
																																			style={{
																																				height:
																																					"200px",
																																				width:
																																					"200px",
																																			}}
																																			src={tp1}
																																			alt="tp1"
																																		/>
																																	</TransformComponent>
																																</TransformWrapper>
																															</MediaQuery>
																															<li>
																																Selanjutnya kita
																																mencari nilai{" "}
																																<InlineMath math=" y " />{" "}
																																dengan
																																mensubstitusikan
																																nilai{" "}
																																<InlineMath math=" x " />
																															</li>

																															<li>
																																Selanjutnya
																																substitusikan&nbsp;
																																<InlineMath math=" x = 1.6" />&nbsp;
																																ke salah satu
																																persamaan.
																																Disini kita
																																memakai&nbsp;
																																<InlineMath math="3x + y = 6" />
																															</li>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="3(1,6) + y = 6" />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math=" 4,8 + y = 6" />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="y = 6- 4,8 " />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="y = 1,2 " />
																															</div>
																														</ul>
																													</p>
																													<div className="d-flex justify-content-center">
																														<button
																															className="btn btn-success btn-sm mb-2 mt-2"
																															onClick={() =>
																																setShow13(true)
																															}
																														>
																															Lanjut
																														</button>
																													</div>
																													{show13 ? (
																														<>
																															<li>
																																Maka diperoleh
																																titik koordinat E
																																adalah
																																<InlineMath math="\space 1,6 \space" /> dan <InlineMath math="\space 1,2 \space"/>
																															</li>
																															<li>
																																Dari gambar daerah
																																penyelesaian di
																																atas maka
																																didapatkan
																																titik-titik
																																koordinat sebagai
																																berikut O(0,0), B(0,2),
																																C(2,0), dan E( 1,6 ,
																																1,2 ) Untuk
																																menentukan nilai
																																maksimumnya,
																																substitusikan
																																setiap titik
																																koordinat ke dalam
																																fungsi objektif
																																yaitu{" "}
																																<InlineMath math="\space z = 400x + 600y \space" />
																															</li>
																															<div className="d-flex justify-content-center">
																																<button
																																	className="btn btn-success btn-sm mb-2 mt-2"
																																	onClick={() =>
																																		setShow14(
																																			true
																																		)
																																	}
																																>
																																	Lanjut
																																</button>
																															</div>
																															{show14 ? (
																																<>
																																	<div className="d-flex justify-content-center">
																																		<table
																																			className="table"
																																			style={{
																																				border:
																																					"2px solid green",
																																				borderCollapse:
																																					"collapse",
																																				width:
																																					"100%",
																																				textAlign:
																																					"center",
																																			}}
																																		>
																																			<tr>
																																				<th
																																					scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}
																																				>
																																					Titik
																																					koordinat
																																				</th>
																																				<th scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math="z = 400x + 600y" />
																																				</th>
																																				<th scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					Hasil
																																				</th>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					O(0,0)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400(0) + 600(0)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					0
																																				</td>
																																			</tr>
																																	
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					B
																																					(0,2)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400(0) + 600(2)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					1200
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					C
																																					(2,0)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400(2) + 600(0)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					800
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					E (1,6
																																					, 1,2)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 400(1,6) + 600(1,2)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					1360
																																				</td>
																																			</tr>
																																		</table>
																																	</div>
																																	<div className="d-flex justify-content-center">
																																		<button
																																			className="btn btn-success btn-sm mb-2 mt-2"
																																			onClick={() =>
																																				setShow15(
																																					true
																																				)
																																			}
																																		>
																																			Lanjut
																																		</button>
																																	</div>
																																	{show15 ? (
																																		<>
																																			<p className="text-center">
																																				{" "}
																																				<b>
																																					Jadi
																																					total
																																					biaya
																																					maksimum
																																					yang
																																					dikeluarkan
																																					Dika
																																					adalah
																																					Rp
																																					1.360,00.
																																				</b>
																																			</p>
																																		</>
																																	) : null}
																																</>
																															) : null}
																														</>
																													) : null}
																												</>
																											) : null}
																										</>
																									) : null}
																								</>
																							) : null}
																						</>
																					) : null}
																				</>
																			) : null}
																		</>
																	) : null}
																</>
															) : null}
														</>
													) : null}
												</>
											) : null}
										</>
									) : null}
								</>
							) : null}
						</>
					) : null}
				</ol>
			</div>
		</div>
	);
};

export default Ctp;
